import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment.prod';
import { DelegateDto } from '@models/users/delegate.dto';
import { MappedSubscriberDto } from '@models/users/mapped-subscriber.dto';
import { SignInDto } from '@models/users/sign-in.dto';
import { SubscriberDto } from '@models/users/subscriber.dto';

@Injectable({
  providedIn: 'root',
})
export class SubscriberService {
  constructor(private http: HttpClient) {}

  getSubscribers() {
    return this.http.get<SubscriberDto[]>(
      environment.host + '/subscribers/list',
    );
  }

  getAgreedSubscribers() {
    return this.http.get<MappedSubscriberDto[]>(
      environment.host + '/subscribers/agreed-list',
    );
  }

  createSubscriber(subs: SubscriberDto[]) {
    return this.http.post<SubscriberDto[]>(
      environment.host + '/subscribers/create',
      subs,
    );
  }

  modifySubscriber(subs: SubscriberDto[]) {
    return this.http.post<SubscriberDto[]>(
      environment.host + '/subscribers/modify',
      subs,
    );
  }

  sendGeneratedCodeEmails(subs: SignInDto[]) {
    return this.http.post<any>(
      environment.host + '/subscribers/send-generated-codes',
      subs,
    );
  }

  removeSubscriber(subs: SubscriberDto[]) {
    return this.http.post<SubscriberDto[]>(
      environment.host + '/subscribers/remove',
      subs,
    );
  }

  editSubscriber(subs: SubscriberDto) {
    return this.http.post<SubscriberDto>(
      environment.host + '/subscribers/edit-info',
      subs,
    );
  }

  getDelegates() {
    return this.http.get<DelegateDto[]>(environment.host + '/delegates/list');
  }

  createDelegate(delegates: DelegateDto[]) {
    return this.http.post<DelegateDto[]>(
      environment.host + '/delegates/create',
      delegates,
    );
  }

  modifyDelegate(delegates: DelegateDto[]) {
    return this.http.post<DelegateDto[]>(
      environment.host + '/delegates/modify',
      delegates,
    );
  }

  removeDelegate(delegates: DelegateDto[]) {
    return this.http.post<DelegateDto[]>(
      environment.host + '/delegates/remove',
      delegates,
    );
  }

  getOrganizationChartInfo() {
    return this.http.get<DelegateDto[]>(
      environment.host + '/organization-chart/view',
    );
  }
}
